import React from 'react';

const ZipCodeIcon = ({ className }) => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width='17'
            height='12'
            viewBox='0 0 17 12'
            fill='none'
            className={className}
        >
            <path
                d='M15.3438 10.6875H2.15625C1.63847 10.6875 1.21875 10.2678 1.21875 9.75V2.25C1.21875 1.73222 1.63847 1.3125 2.15625 1.3125H15.3438C15.8615 1.3125 16.2812 1.73222 16.2812 2.25V9.75C16.2812 10.2678 15.8615 10.6875 15.3438 10.6875Z'
                stroke='#00225F'
                strokeWidth='0.9375'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M4.0625 6L5.9375 7.875'
                stroke='#00225F'
                strokeWidth='0.9375'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M5.9375 6L4.0625 7.875'
                stroke='#00225F'
                strokeWidth='0.9375'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M7.8125 6L9.6875 7.875'
                stroke='#00225F'
                strokeWidth='0.9375'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M9.6875 6L7.8125 7.875'
                stroke='#00225F'
                strokeWidth='0.9375'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M11.5625 6L13.4375 7.875'
                stroke='#00225F'
                strokeWidth='0.9375'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M13.4375 6L11.5625 7.875'
                stroke='#00225F'
                strokeWidth='0.9375'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M4.0625 4.125H5.9375'
                stroke='#00225F'
                strokeWidth='0.9375'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M7.8125 4.125H9.6875'
                stroke='#00225F'
                strokeWidth='0.9375'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M11.5625 4.125H13.4375'
                stroke='#00225F'
                strokeWidth='0.9375'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    );
};

export { ZipCodeIcon };
